import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerAnomalyMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('anomalies', locale)
}
